<template>
    <div id="payment-details">
        <div class="container-fluid">
            <div class="row">
                <div class="col-4 background qf-pt-70px qf-pb-70px">
                    <div class="row justify-content-center align-items-center py-5">
                        <div class="col-12 text-center">
                            <router-link to="/">
                                <img src="../../assets/logo2.png" class="img-fluid" alt="ТМ">
                            </router-link>
                        </div>
                    </div>
                    <div class="row py-5 justify-content-center">
                        <div class="col-12 text-center pb-3">
                            <h6 class="text-muted text-uppercase">{{$ml.get('products_in_cart')}}</h6>
                        </div>
                        <div class="col-12">
                            <div class="d-flex justify-content-center">
                                <Plan class="qf-no-hover" :plan="$store.state.plans[$store.state.selectedPlanIndex]"
                                v-if="$store.state.plans.length">
                                    <div class="d-flex">
                                        <div class="col text-left h4 pb-0">
                                            {{$ml.get('TOTAL')}}:
                                        </div>
                                        <div class="col text-right h4 pb-0">
                                            ${{$store.state.plans[$store.state.selectedPlanIndex].yearly_price}}
                                        </div>
                                    </div>
                                </Plan>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-8 background-signup qf-pb-70px">
                    <div class="row">
                        <div class="col-11 offset-1 pt-5">
                            <a href="#!" @click.prevent="goBack">
                                <font-awesome-icon icon="chevron-left" size="2x"/>
                            </a>
                        </div>
                    </div>
                    <div class="row justify-content-center align-items-center">
                        <div class="col-5 py-5">
                            <div class="d-flex align-items-center">
                                <div>
                                    <div class="qf-sign-up-circle mx-auto" :class="{'qf-active': $route.name === 'Registration'}"></div>
                                    DETAILS
                                </div>
                                <div class="flex-grow-1 qf-vertical-line"></div>
                                <div>
                                    <div class="qf-sign-up-circle mx-auto" :class="{'qf-active': $route.name === 'Billing'}"></div>
                                    PAYMENT
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "payment-details",
        beforeMount(){
            if (!this.$store.getters.hasData('plans')) {
                this.$store.dispatch('plans').then(response => {
                    this.plans = response;
                }).catch(error => {
                });
            }
        },
        methods: {
            goBack() {
                if (window.history.length > 1) {
                    this.$router.go(-1);
                } else {
                    this.$router.push('/');
                }
            }
        },
    }
</script>

<style scoped>
    .background-signup,
    .background {
        background-repeat: no-repeat;
        background-size: cover;
        background-attachment: fixed;
    }

    .background {
        background-image: url("../../assets/background.jpg");
        color: #ffffff;
    }

    .background-signup {
        background-image: url("../../assets/background-signup.jpg");
    }

    .qf-sign-up-circle {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 2px solid transparent;
        position: relative;
    }

    .qf-sign-up-circle.qf-active {
        border-color: #002e42;
    }

    .qf-sign-up-circle:before {
        content: '';
        display: block;
        position: absolute;
        width: 6px;
        height: 6px;
        background: #002e42;
        border-radius: 50%;
        top: 15px;
        left: 15px;
    }

    .qf-vertical-line {
        height: 4px;
        background: #002e42;
        margin-bottom: 22px;
        border-radius: 2px;
    }
</style>